import { render, staticRenderFns } from "./BroadcastTeacher.vue?vue&type=template&id=6a2d78aa&"
import script from "./BroadcastTeacher.vue?vue&type=script&lang=js&"
export * from "./BroadcastTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports